import { createHead } from '@unhead/vue/client'
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'
import { ClipboardModule, ContextMenuModule, LicenseManager, SetFilterModule } from 'ag-grid-enterprise'
import { createApp } from 'vue'
import App from './App.vue'
import directives from './directives'
import { i18n } from './modules/i18n'
import { nprogress } from './modules/nprogress'
import { pinia } from './modules/pinia'
import { router } from './modules/router'
import './style.css'
import '@eci-saas/shared/overrides.css'
import '@eci-saas/shared/flow-overrides.css'

// AG Grid 模块注册（在应用启动时完成，确保打包后也能正确工作）
ModuleRegistry.registerModules([AllCommunityModule, ContextMenuModule, ClipboardModule, SetFilterModule])

// AG Grid Enterprise License Key
LicenseManager.setLicenseKey('[TRIAL]_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-115195}_is_granted_for_evaluation_only___Use_in_production_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_purchasing_a_production_key_please_contact_info@ag-grid.com___You_are_granted_a_{Single_Application}_Developer_License_for_one_application_only___All_Front-End_JavaScript_developers_working_on_the_application_would_need_to_be_licensed___This_key_will_deactivate_on_{9 January 2026}____[v3]_[0102]_MTc2NzkxNjgwMDAwMA==a6a38364fe091825cd15a67722f6642f')

const head = createHead()

createApp(App)
  .use(router)
  .use(i18n)
  .use(pinia)
  .use(head)
  .use(nprogress)
  .use(directives)
  .mount('#app')
